export function buildTokenLoginUrl(portalUrl, token) {
    if (!portalUrl || !token) {
        return null;
    }

    let parsed;

    try {
        parsed = new URL(String(portalUrl).trim());
    } catch (error) {
        return null;
    }

    if (parsed.protocol !== "http:" && parsed.protocol !== "https:") {
        return null;
    }

    return `${parsed.origin}/token-login?token=${encodeURIComponent(token)}`;
}
